import { useParams } from "@tanstack/react-router"

export const useCommunityId = () => {
  try {
    const params = useParams({ strict: false })
    
    if (params.communityId) {
      const id = parseInt(params.communityId, 10)
      return isNaN(id) ? undefined : id
    }
    
    return undefined
  } catch (error) {
    // Fallback to URL parsing
    const match = window.location.pathname.match(/\/community\/(\d+)/)
    const id = match ? parseInt(match[1], 10) : undefined
    return id
  }
}
